import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';
import { CustomValidators } from 'src/validators';
import * as moment from 'moment';
import { DomSanitizer } from '@angular/platform-browser';
import { PlatformLocation } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-step-four',
  templateUrl: './step-four.component.html',
  styleUrls: ['./step-four.component.scss']
})
export class StepFourComponent implements OnInit {

  formEducation2: FormGroup;
  formEducation: FormGroup;
  @Output() formObserver: Subject<FormGroup>;
  @Output() submit: EventEmitter<boolean>;
  educations: Array<any>;
  showForm: boolean = true;
  mauticFormSrc: any = null;

  constructor(
    fb: FormBuilder,
    private http: HttpService,
    private errorReport: ErrorReportService,
    private sanitazer: DomSanitizer,
    private pLocation: PlatformLocation,
    private router: Router,
  ) {

    this.formEducation = fb.group({
      institutionName: [null],
      educationLevel: [null, Validators.required],
      courseName: [null],
      currentCourse: [false],
      dateStart: [null],
      dateEnd: [null],
    })
    this.formEducation2 = fb.group({
      institutionName: [null, Validators.required],
      educationLevel: [null, Validators.required],
      courseName: [null, Validators.required],
      currentCourse: [false],
      dateStart: [null, [CustomValidators.beforeDate('dateEnd', 'MMyyyy'), CustomValidators.date('MMyyyy')]],
      dateEnd: [null, [CustomValidators.maxDate(moment(), 'MMyyyy'), CustomValidators.date('MMyyyy')]],
    });
    this.formObserver = new Subject<FormGroup>();
    this.formObserver = new Subject<FormGroup>();
    this.submit = new EventEmitter<any>();
    this.educations = new Array<any>();

  }

  ngOnInit(): void {
    //this.formObserver.next(this.form);
  }

  onSubmit(): void {

    const params = new URLSearchParams();
    params.append('email', localStorage.getItem('email'));
    const bHref = this.pLocation.getBaseHrefFromDOM();
    this.mauticFormSrc = this.sanitazer
      .bypassSecurityTrustResourceUrl(`${bHref}mautic-form/step-four?${params.toString()}`);

    if (this.formEducation.dirty) {
      this.addEducation();
    }

    const user = {
      email: localStorage.getItem('email'),
      subject: 'Colloca | Bem-vindo(a) à nossa plataforma!',
      fullname: localStorage.getItem('name'),
      new: 'true',
      template: '300d9cb2-4bb3-446c-9ce1-94e1896eafee'
    }

    this.http.save('onsignal:sendEmail', user)
      .subscribe(
        (result: any) => {

          if (result.type === 'OK') {
            //console.log('email enviado');
          }
        },
        err => this.errorReport.showMessage(err)
      );

    if (this.educations.length) {

      const data = {
        email: localStorage.getItem('email'),
        educations: JSON.stringify(this.educations),
      }

      this.http.save('education_experience', data)
        .subscribe(
          (result: any) => {

            if (result.type === 'OK') {
              this.submit.emit();
              setTimeout(() => {
                this.doneAll();
              }, 500);
            }
          },
          err => this.errorReport.showMessage(err)
        );


    } else {
      this.doneAll();
      this.submit.emit();
    }

  }

  // addEducation() {

  //   if(!this.formEducation.invalid) {

  //     const data = this.formEducation.getRawValue();

  //     data.dateStart = moment(data.dateStart, 'MM/YYYY').format('YYYY-MM-DD');

  //     if(data.dateEnd)  
  //       data.dateEnd = moment(data.dateEnd, 'MM/YYYY').format('YYYY-MM-DD');

  //     this.educations.push({ ...data });
  //     this.formEducation.reset({ currentCourse: false });
  //     this.formEducation.markAsPristine();
  //     this.showForm = false;

  //   }

  // }

  addEducation() {

    if (!this.formEducation.invalid && !this.formEducation2.invalid) {
      const level = this.formEducation.get('educationLevel').value;
      const data2 = this.formEducation2.getRawValue();

      const info = {
        email: localStorage.getItem('email'),
        educationLevel: level
      }

      this.http.save('education_level', info)
        .subscribe(
          (result: any) => {
            if (result.type === 'OK'){
              // console.log('Escola', 'ok');
            }
          },
          err => this.errorReport.showMessage(err)
        );

      // data1.dateStart = moment(data1.dateStart, 'MM/YYYY').format('YYYY-MM-DD');
      // if (data1.dateEnd) data1.dateEnd = moment(data1.dateEnd, 'MM/YYYY').format('YYYY-MM-DD');

      data2.dateStart = moment(data2.dateStart, 'MM/YYYY').format('YYYY-MM-DD');
      if (data2.dateEnd) data2.dateEnd = moment(data2.dateEnd, 'MM/YYYY').format('YYYY-MM-DD');

      //this.educations.push({ ...data1 });
      this.educations.push({ ...data2 });

      this.formEducation.reset({ currentCourse: false });
      this.formEducation.markAsPristine();
      this.formEducation2.reset({ currentCourse: false });
      this.formEducation2.markAsPristine();
      this.showForm = false;

    }

  }

  resetForm() {

    this.formEducation.reset({ currentCourse: false });
    this.showForm = false;

  }

  removeItem(i: number) {

    if (!confirm('Deseja remover esse item'))
      return;

    this.educations.splice(i, 1);

  }

  // toggleDateValidation() {
  //   if (this.formEducation.get('currentCourse').value) {
  //     this.formEducation.get('dateEnd').clearValidators();
  //   } else {
  //     this.formEducation.get('dateEnd').setValidators([CustomValidators.departureDate('currentCourse'), CustomValidators.maxDate(moment(), 'MMyyyy'), CustomValidators.date('MMyyyy')]);
  //   }
  //   this.formEducation.get('dateEnd').updateValueAndValidity();
  // }

  toggleDateValidation(form: FormGroup) {
    if (form.get('currentCourse').value) {
      form.get('dateEnd').clearValidators();
    } else {
      form.get('dateEnd').setValidators([CustomValidators.departureDate('currentCourse'), CustomValidators.maxDate(moment(), 'MMyyyy'), CustomValidators.date('MMyyyy')]);
    }
    form.get('dateEnd').updateValueAndValidity();
  }

  doneAll() {
    const data = {
      email: localStorage.getItem('email'),
      password: localStorage.getItem('password')
    }

    this.http.save('auth:login', data)
      .subscribe(
        (result: any) => {
          if (result.data) {
            localStorage.setItem('token', JSON.stringify(result.data));
            setTimeout(() => this.router.navigate(['/customer/welcome']), 250);
          }
        }
      )
  }

}
